import type { ProductStatus } from '../../recoil/types/onsaTypes';
import CarNumberOfClaimsStep from './car/CarNumberOfClaimsStep';
import CarAlreadyInsured from './car/CarAlreadyInsured';
import CarSeniorityStep from './car/CarSeniorityStep';
import CarAgeOfOldestInHousehold from './car/CarAgeOfOldestInHousehold';
import type { AllCoverablesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { findCarWithMatchingProperty } from '../../utils/coverablesUtil';

type PostLoginQuestionsStepsConfig = Array<{
    id: string;
    disabled?: boolean;
    Component: React.ComponentType<{
        goNext: () => void;
        goPrevious: () => void;
    }>;
}>;

export const getPostLoginQuestionsConfig = (
    currentProduct: ProductStatus,
    shoppingBasketCoverables: AllCoverablesDTO,
    onsaCoverables: AllCoverablesOnsaDTO,
    isLoggedIn: boolean,
    hasReplacementCars: boolean,
    isVehicleSeniorityInherited: boolean,
    shouldSendClaimsHistory: boolean
): PostLoginQuestionsStepsConfig => {
    switch (currentProduct?.flavourName) {
        case 'Bilforsikring':
            return getCarConfig(
                currentProduct,
                shoppingBasketCoverables,
                onsaCoverables,
                isLoggedIn,
                hasReplacementCars,
                isVehicleSeniorityInherited,
                shouldSendClaimsHistory
            );
        default:
            return [];
    }
};

const getCarConfig = (
    currentProduct: ProductStatus,
    shoppingBasketCoverables: AllCoverablesDTO,
    onsaCoverables: AllCoverablesOnsaDTO,
    isLoggedIn: boolean,
    hasReplacementCars: boolean,
    isVehicleSeniorityInherited: boolean,
    shouldSendClaimsHistory: boolean
): PostLoginQuestionsStepsConfig => {
    return [
        {
            id: 'AlreadyInsuredCar',
            Component: CarAlreadyInsured,
            disabled: !isLoggedIn || !hasReplacementCars
        },
        {
            id: 'CarAgeOfOldestInHousehold',
            Component: CarAgeOfOldestInHousehold,
            disabled:
                findCarWithMatchingProperty(
                    shoppingBasketCoverables,
                    onsaCoverables,
                    currentProduct.fixedId,
                    'ageOfOldestInHousehold'
                ) !== undefined
        },
        {
            id: 'SeniorityStep',
            Component: CarSeniorityStep,
            disabled:
                findCarWithMatchingProperty(
                    shoppingBasketCoverables,
                    onsaCoverables,
                    currentProduct.fixedId,
                    'drivingExperience'
                ) !== undefined ||
                hasReplacementCars ||
                isVehicleSeniorityInherited
        },
        {
            id: 'CarNumberOfClaimsStep',
            Component: CarNumberOfClaimsStep,
            disabled:
                findCarWithMatchingProperty(
                    shoppingBasketCoverables,
                    onsaCoverables,
                    currentProduct.fixedId,
                    'numberOfClaims'
                ) !== undefined ||
                hasReplacementCars ||
                !shouldSendClaimsHistory
        }
    ];
};
